export default __webpack_public_path__ + "static/media/zhuanli1.95fe9624.jpg";